import { Button } from '@mui/material';
import { AddCircle } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

type GroupMessageEmailActionButtonsProps = {
  openTemplatePicker: (open: boolean) => void;
};

const GroupMessageEmailActionButtons = (props: GroupMessageEmailActionButtonsProps) => {
  const { openTemplatePicker } = props;

  const { t } = useTranslation(['common']);
  return (
    <Button variant='contained' color='primary' startIcon={<AddCircle />} onClick={() => openTemplatePicker(true)} disableElevation>
      {t('common:button.create')}
    </Button>
  );
};

export default GroupMessageEmailActionButtons;
